export enum ProgressNodeTypeEnum {
  progressNodeComp = 'ProgressNodeComponent',
  videoNodeComp = 'VideoNodeComponent',
  dinkusNodeComp = 'DinkusNodeComponent',
}
